import esriComponent from './esri-component';
import visible from './visible';

export default {
  inject: ['getLayers'],
  mixins: [esriComponent, visible],
  props: {
    // The Layer properties.
    properties: {
      type: Object,
      required: false,
      default: () => ({})
    },
  },
  watch: {
    visible (value) {
      this.set('visible', value);
    },
    'properties.opacity' (value) {
      this.set('opacity', value);
    }
  },
  methods: {
    /**
     * @Override
     */
    beforeInit () {
      return this.wait(this.getLayers);
    },
    /**
     * @Override
     */
    async mount () {
      this.$esriWatcher = this.$esriObject.watch('visible', visible => {
        this.setVisible(visible);
      });

      const layers = this.getLayers();
      if (layers) {
        layers.add(this.$esriObject);
      }
    },
    /**
     * @Override
     */
    async unmount () {
      this.$esriWatcher.remove();

      const layers = this.getLayers();
      if (layers) {
        layers.remove(this.$esriObject);
      }
    }
  }
};
